export const FETCH_AGENT_SCHEDULE = 'FETCH_AGENT_SCHEDULE';
export const FETCH_MANAGEMENT_UNIT = 'FETCH_MANAGEMENT_UNIT';
export const FETCH_TEAM = 'FETCH_TEAM';
export const WEEKLY_SCHEDULE_RECEIVED = 'WEEKLY_SCHEDULE_RECEIVED';
export const MANAGEMENT_UNIT_RECEIVED = 'MANAGEMENT_UNIT_RECEIVED';
export const TEAM_RECEIVED = 'TEAM_RECEIVED';
export const DATE_SELECTED = 'DATE_SELECTED';
export const FETCH_MUS = 'FETCH_MUS';
export const RECEIVED_MUS = 'RECEIVED_MUS';
export const FETCH_AGENT_SCHEDULES = 'FETCH_AGENT_SCHEDULES';
export const RECEIVED_AGENT_SCHEDULES = 'RECEIVED_AGENT_SCHEDULES';


// WEBPACK FOOTER //
// ./src/features/schedules/redux/constants.js